import { render } from "./DeliveryPriceBaseOnLocation.vue?vue&type=template&id=12a30aef"
import script from "./DeliveryPriceBaseOnLocation.vue?vue&type=script&lang=js"
export * from "./DeliveryPriceBaseOnLocation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/technopoorhosein-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__